import axios from 'axios';

const API_BASE_URL = 'https://auth.air360.app';

export const sendVerificationCode = async (email) => {
    try {
        // Input validation
        if (!email || typeof email !== 'string' || !email.includes('@')) {
            throw new Error('Invalid email address provided');
        }

        console.log('Sending request to API:', { email });

        // Make the API request
        const response = await axios.post(`${API_BASE_URL}/send-verification-code`, new URLSearchParams({ email }));

        // Validate response structure
        if (!response || !response.data) {
            throw new Error('Unexpected API response format');
        }

        console.log('Response from API:', response.data);

        // Return the data
        return response.data;
    } catch (error) {
        // Detailed error logging
        console.error(`Error in sendVerificationCode: ${error.message}`, {
            endpoint: `${API_BASE_URL}/send-verification-code`,
            email,
            error: error.response ? error.response.data : error.message,
        });

        // Re-throw the error with additional context
        throw new Error(`Failed to send verification code: ${error.message}`);
    }
};

export const verifyCode = async (email, code) => {
    try {
        // Input validation
        if (!email || typeof email !== 'string' || !email.includes('@')) {
            throw new Error('Invalid email address provided.');
        }
        if (!code || isNaN(code) || code.toString().length !== 6) {
            throw new Error('Invalid verification code provided.');
        }

        //console.log('Verifying code:', { email, code });

        const params = new URLSearchParams({ email, code });

        // Make the API request
        const response = await axios.post(`${API_BASE_URL}/verify-code`, params);

        // Validate the response structure
        if (!response || !response.data) {
            throw new Error('Unexpected API response format.');
        }

        //console.log('Verification successful:', response.data);

        return response.data;
    } catch (error) {
        // Log the error details for debugging
        console.error('Error in verifyCode:', {
            email,
            code,
            error: error.response?.data || error.message,
        });

        // Re-throw the error with additional context for UI handling
        throw new Error(`Verification failed: ${error.response?.data?.message || error.message}`);
    }
};

export const resendVerificationToken = async () => {
    const response = await axios.get(`${API_BASE_URL}/resend`);
    return response.data;
};